import dayjs, { Dayjs } from 'dayjs'
import { useEffect, useState } from 'react'

import { OLMSApiService } from '@/shared/apis'

export const useRunsheetScheduledDates = () => {
  const [scheduledDates, setScheduledDates] = useState<Dayjs[]>([])

  useEffect(() => {
    OLMSApiService.get<string[]>('/runsheet/scheduledDates').then((results) => {
      if (!results) return

      const dates = results.map(date => dayjs(date, 'DD/MM/YYYY'))

      setScheduledDates(dates)
    })
  }, [])

  return {
    scheduledDates,
    setScheduledDates,
  }
}